import type { ComponentProps } from "react";
import { styled } from "@repo/styled-system/jsx";

export type SpanProps = ComponentProps<typeof Span>;
export const Span = styled("span");
